import React, { useState, useEffect } from 'react';
import { useHistory } from "react-router-dom";
import Header from '../../Shared/Header';
import Footer from '../../Shared/Footer';
import Footer2 from '../../Shared/Footer2';
import '../../../css/Announcement/Notification.css';
import MetaDecorator from '../../../ReactHelmet/MetaDecorator';
import TitleDescription from '../../../Data/Shared/TitleDescription.json';
import { ApiCall } from '../../../Services/utils/ApiCall';
import { utilityBaseURL } from '../../../Services/config/apiGateway';
import { NOTIFICATION_BY_USER_ENDPOINT } from '../../../Services/config/apiEndPoints';
import AddProfileModal from '../../Shared/GenericModalError';
import { AES, enc } from 'crypto-js';
import { useSelector } from 'react-redux';
import { connect } from 'react-redux';


const Notification = (props) => {
    let history = useHistory();
    const userProfileDataR = useSelector(state => JSON.parse(AES.decrypt(state.userProfileInfoReducer.data, 'TPT_CARGO_CONNECT').toString(enc.Utf8)));
    const manageProfileDataR = useSelector(state => state.manageProfileReducer.data);
    const [announcementData, setAnnouncementData] = useState([]);
    const [hasOpen, setHasopen] = useState(false);
    const [notificationTime] = useState([]);


    useEffect(() => {
        ApiCall(
            'GET',
            utilityBaseURL + NOTIFICATION_BY_USER_ENDPOINT + `?user=${userProfileDataR?.userEmail}`,
            {},
            {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
        ).then((apiData) => {
            if (apiData.flag != -1) {
                if (apiData.flag == 500) {
                    setHasopen(true);
                } else {
                    console.log('I am 200!');
                    timeDifference(apiData);
                    setAnnouncementData(apiData);
                }
            }
        });
    }, []);

    const setNavigationPath = (category) => {
        if (category === "Announcement") {
            return "announcementDetails";
        } else if (category?.toLowerCase() == "nominate request") {
            return "NominateRequestDetails";
        } else if (category?.toLowerCase() == "transportation service") {
            return "QuotationHistory";
        } else if (category?.toLowerCase() === "new service") {
            let path = '';
            manageProfileDataR?.selectedProfileType == "Requester"
                ?
                path = "ServiceSelection"
                :
                path = "MyServicesSettings"

            return path;
        }
        else if (category?.toLowerCase() === "resolve quote") {
            return "ServiceRequest";
        }
        else if (category?.toLowerCase() === "bid quote") {
            return "QuotationHistory";
        } else {
            return "DefaultRoute";
        }
    }
    const handleAnnouncement = (event) => {
        let navigationPath = setNavigationPath(
            announcementData[event]?.category
        );

        announcementData?.find((name) => {

            if (name.id === announcementData[event].id) {
                if (name.category == "Announcement") {
                    history.push({
                        pathname: `/${navigationPath}/${name.id}`,
                    });
                } else {
                    history.push({
                        pathname: `/${navigationPath}`,
                    });
                }
            }
        })
    }
    const onCloseModal = () => {
        setHasopen(false);
    };
    const timeDifference = (data) => {
        console.log("time difference log");
        var currentTime = new Date().getTime();
        var msPerMinute = 60 * 1000;
        var msPerHour = msPerMinute * 60;
        var msPerDay = msPerHour * 24;
        var msPerMonth = msPerDay * 30;
        var msPerYear = msPerDay * 365;

        data?.map((data1) => {
            let elapsed = currentTime - (data1?.publishTime - ( 160 * 1000));// 160 seconds
            if (elapsed < msPerMinute) {
                notificationTime.push(Math.round(elapsed / 1000) + ' seconds ago');
            }
            else if (elapsed < msPerHour) {
                notificationTime.push(Math.round(elapsed / msPerMinute) + ' minutes ago');
            }
            else if (elapsed < msPerDay) {
                notificationTime.push(Math.round(elapsed / msPerHour) + ' hours ago');
            }
            else if (elapsed < msPerMonth) {
                notificationTime.push(Math.round(elapsed / msPerDay) + ' days ago');

            }
            else if (elapsed < msPerYear) {
                notificationTime.push(Math.round(elapsed / msPerMonth) + ' months ago');
            }
            else {
                notificationTime.push(Math.round(elapsed / msPerYear) + ' years ago');
            }
        })
    }

    return (
        <div class="notifioutcolor" >
            <MetaDecorator title={TitleDescription.notificationPageTitle} description={TitleDescription.notificationPageDescription} />
            <Header tilesFetched={() => { }} />
            <div class="nofullNotification">
                <div id="nobox1Notification">
                    <nav class="nononavbar">
                        <div className="nonavbarname12">
                            <small id="nonavc"> Notifications</small>
                        </div>
                    </nav>
                    <hr class="hr1" />
                    <div class="notificationmaincard">
                        <div>
                            <div class="navcardnotification" >
                                {(announcementData?.map((name, index) => {
                                    return (
                                        <div key={index} onClick={() => handleAnnouncement(index)}>
                                            <div class="notificationrow1" >
                                                <div class="notificationinput1">
                                                    <small class="title">{name?.title}</small>
                                                </div>
                                                <div><small class="time">{notificationTime[index]}</small></div>
                                            </div>
                                            <div class="data1">
                                                <a class="data" >{name?.description}
                                                    <small class="dataclickhere">Check this here {'>'}</small></a></div>
                                            <hr class="hr1" />
                                        </div>
                                    );
                                }))}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="notificafooter01">
                <Footer />
            </div>
            <div class="notificafooter02">
                <Footer2 />
            </div>
            {hasOpen ? <AddProfileModal hasOpen={hasOpen} onCloseModal={onCloseModal} >
                <div>
                    <div class="successtext1outercreatepreadvise">
                        <small class="addprofilemodalsmall">No New Notifications</small>
                    </div>
                </div>
            </AddProfileModal> : null}
        </div>
    );
}

export default Notification;